import { AxiosRequestConfig } from 'axios'
import createAPIClient from '../services/apiClient'
import { Level, LevelInput } from '../types'

const api = createAPIClient('/v2')

export async function getLevels(config?: AxiosRequestConfig): Promise<Level[]> {
  const response = await api.get('/levels', config)

  return response.data
}

export async function getLevelsByProjectId(
  projectId: number,
  config?: AxiosRequestConfig
): Promise<Level[]> {
  const response = await api.get(`/projects/${projectId}/levels`, config)

  return response.data
}

export async function getLevel(id: number, config?: AxiosRequestConfig): Promise<Level> {
  const response = await api.get(`/levels/${id}`, config)

  return response.data
}

export async function createLevel(input: LevelInput, config?: AxiosRequestConfig): Promise<Level> {
  const response = await api.post('/levels', input, config)

  return response.data
}

export async function updateLevel(
  id: number,
  input: LevelInput,
  config?: AxiosRequestConfig
): Promise<Level> {
  const response = await api.put(`/levels/${id}`, input, config)

  return response.data
}

export async function deleteLevel(id: number, config?: AxiosRequestConfig): Promise<void> {
  await api.delete(`/levels/${id}`, config)
}

export default {
  getLevels,
  getLevelsByProjectId,
  getLevel,
  createLevel,
  updateLevel,
  deleteLevel
}
